

export const title = "#6A6A6A"
export const hover = "#6259ca"